<template>
    <div class="devices-list__block" v-if="deviceData" @click="openChart">
        <device-status :device="deviceData" :showLocation="showLocation" :edit="edit"/>
        <v-layout row class="devices-list__block__title w-100" :class="{'device-btns-edit': edit}">
            <device-title :device="deviceData"></device-title>
        </v-layout>
        <div class="small-text mt-3" v-if="deviceData.state">
            <span class="mr-2" v-if="deviceData.state.temperature">
                Температура: {{ (deviceData.state.temperature).toFixed(1) }}°C;
            </span>
            <span v-if="deviceData.state.humidity">Влажность: {{ (deviceData.state.humidity).toFixed(1) }}%</span>
        </div>
        <ModalCharts ref="modalCharts" :device-u-i-d="deviceData.uid" device-type="temp"></ModalCharts>
    </div>
</template>

<script>
import ModalCharts from "@/components/modals/ModalCharts";
export default {
    name: "ThermometerDevice",
    components: {ModalCharts},
    props: {
        device: {
            type: [Array, Object],
            default: null,
        },
        edit: {
            type: Boolean,
            default: false,
        },
        showLocation: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            deviceData: {},
        };
    },
    created() {
        this.deviceData = this.device;
    },
    watch: {
        device(val) {
            if (val) {
                this.deviceData = val;
            }
        },
    },
    methods: {
        openChart() {
            if (!this.deviceData.is_action) {
                this.$refs.modalCharts.open();
            }
        },
    },
}
</script>